<ng-container *ngIf="exibirTela">
<div class="ato-republicado" *ngIf="atoCentral.foiRepublicado">
    <p>Este ato sofreu republicação. Consulte a versão republicada para ver seus relacionamentos.</p>
</div>

<table *ngIf="!atoCentral.foiRepublicado">
    <thead>
        <tr>
            <th>
                <span *ngIf="atoCentralRetificador">
                    Atos modificadores do ato retificador
                </span>
                <span *ngIf="!atoCentralRetificador">
                    Atos modificadores do(a) {{ atoCentral.epigrafeBase }}, de {{ atoCentral.dataAtoDMY.substring(6) }}
                </span>
            </th>
            <td></td>
            <th>
                <span *ngIf="atoCentralRetificador">
                    Ato que foi retificado
                </span>
                <span *ngIf="!atoCentralRetificador">
                    Atos modificados pelo(a) {{ atoCentral.epigrafeBase }}, de {{ atoCentral.dataAtoDMY.substring(6) }}
                </span>
            </th>
        </tr>
        <tr>
            <td class="filtros">
                <ng-container *ngIf="filtrosPoloAtivo.length > 0">
                    <span class="label">
                        Filtros
                    </span>
                    <span class="filtro" *ngFor="let filtro of filtrosPoloAtivo">
                        <span>
                            <ng-container *ngTemplateOutlet="circuloFiltro;context:{filtro:filtro}"></ng-container>
                        </span>
                    </span>
                </ng-container>
            </td>
            <td></td>
            <td class="filtros">
                <ng-container *ngIf="filtrosPoloPassivo.length > 0">
                    <span class="label">
                        Filtros
                    </span>
                    <span class="filtro" *ngFor="let filtro of filtrosPoloPassivo">
                        <span>
                            <ng-container *ngTemplateOutlet="circuloFiltro;context:{filtro:filtro}"></ng-container>
                        </span>
                    </span>
                </ng-container>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="impactos polo-ativo">
                <div class="nao-modificou-ato" *ngIf="mapaPoloAtivo.length === 0">
                    Este ato ainda não sofreu modificações por outros atos.
                </div>
                <div class="mapa-polo" *ngIf="mapaPoloAtivo.length > 0">
                    <ul class="lista-anos">
                        <ng-container *ngFor="let mapaAno of mapaPoloAtivo">
                            <li class="item-anos">
                                <div class="anos">
                                    <span class="collapse-ano">
                                        <i *ngIf="mapaAno.expandir"
                                            class="material-icons icon-24"
                                            title="retrair"
                                            (click)="mapaAno.expandir = false">expand_less</i>
                                        <i *ngIf="!mapaAno.expandir"
                                            class="material-icons icon-24"
                                            title="expandir"
                                            (click)="mapaAno.expandir = true">expand_more</i>
                                    </span>
                                    <span class="ano">
                                        {{ mapaAno.ano }}
                                    </span>
                                    <ng-container *ngTemplateOutlet="qtdImpactosAno; context:{quantidade:mapaAno.impactos.length}"></ng-container>
                                </div>

                                <ul class="lista-impactos" *ngIf="mapaAno.expandir">
                                    <ng-container *ngFor="let impacto of buscarAtosFiltrados(mapaAno.ano, false)">
                                        <li class="item-impactos">
                                            <span style="float:right; margin-right:0px">
                                                <ng-container *ngTemplateOutlet="circuloGrande; context:{impacto:impacto}"></ng-container>
                                            </span>
                                            <div class="impacto" [style]="getStyleCorVigencia(impacto.vigencia)"
                                                    (click)="singleClick(impacto)"
                                                    (dblclick)="doubleClick(impacto)">
                                                <ng-container *ngIf="impacto.vigencia === 5">
                                                    <span class="descricao">Retificação</span>
                                                    <div class="data">
                                                        publicada em {{ impacto.dataPublicacaoDMY }}
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="impacto.vigencia !== 5">
                                                    <span class="descricao">
                                                        {{ impacto.epigrafeBase }}
                                                    </span>
                                                    <div class="data">
                                                        {{ impacto.dataAtoDMY }}
                                                    </div>
                                                </ng-container>
                                                <div class="republicador" *ngIf="impacto.ehRepublicador">
                                                    (Republicação)
                                                </div>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </td>

            <td class="ato-central">
                <div id="ato-central" class="ato" [style]="getStyleCorVigencia(atoCentral.vigencia)">
                    <span class="seta-esquerda possui-seta" [style]="getEstiloSeta(false)"></span>
                    <span class="seta-direita possui-seta" [style]="getEstiloSeta(true)"></span>
                    <input type="hidden" value="" />
                    <div class="descricao" *ngIf="atoCentralRetificador">
                        Retificação
                    </div>
                    <div class="descricao" *ngIf="!atoCentralRetificador">
                        <div>
                            {{ atoCentral.epigrafeBase }}
                        </div>
                        <div class="data">
                            {{ atoCentral.dataAtoDMY }}
                        </div>
                    </div>
                    <div class="data" *ngIf="atoCentral.ehRepublicador">(Republicação)</div>
                </div>
            </td>

            <td class="impactos polo-passivo">
                <div class="nao-modificou-ato" *ngIf="mapaPoloPassivo.length === 0">
                    Este ato não modificou nenhum ato.
                </div>
                <div class="mapa-polo" *ngIf="mapaPoloPassivo.length > 0">
                    <ul class="lista-anos">
                        <ng-container *ngFor="let mapaAno of mapaPoloPassivo">
                            <li class="item-anos">
                                <ul class="lista-impactos" *ngIf="mapaAno.expandir">
                                    <ng-container *ngFor="let impacto of buscarAtosFiltrados(mapaAno.ano, true)">
                                        <li class="item-impactos filtro-rev">
                                            <span style="float:left">
                                                <ng-container *ngTemplateOutlet="circuloGrande; context:{impacto:impacto}"></ng-container>
                                            </span>
                                            <div class="impacto" [style]="getStyleCorVigencia(impacto.vigencia)"
                                                    (click)="singleClick(impacto)"
                                                    (dblclick)="doubleClick(impacto)">
                                                <ng-container *ngIf="impacto.vigencia === 5">
                                                    <span class="descricao">Retificação</span>
                                                    <div class="data">
                                                        publicada em {{ impacto.dataPublicacaoDMY }}
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="impacto.vigencia !== 5">
                                                    <span class="descricao">
                                                        {{ impacto.epigrafeBase }}
                                                    </span>
                                                    <div class="data">
                                                        {{ impacto.dataAtoDMY }}
                                                    </div>
                                                </ng-container>
                                                <div class="republicador" *ngIf="impacto.ehRepublicador">
                                                    (Republicação)
                                                </div>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>
                                <div class="anos">
                                    <ng-container *ngTemplateOutlet="qtdImpactosAno; context:{quantidade:mapaAno.impactos.length}"></ng-container>
                                    <span class="ano">
                                        {{ mapaAno.ano }}
                                    </span>
                                    <span class="collapse-ano">
                                        <i *ngIf="mapaAno.expandir"
                                            class="material-icons icon-24"
                                            title="retrair"
                                            (click)="mapaAno.expandir = false">expand_less</i>
                                        <i *ngIf="!mapaAno.expandir"
                                            class="material-icons icon-24"
                                            title="expandir"
                                            (click)="mapaAno.expandir = true">expand_more</i>
                                    </span>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </td>
        </tr>
    </tbody>
</table>

<div class="legendas">
    <p>Legenda</p>
    <br />
    <ul class="legenda cores-ato">
        <li *ngFor="let legenda of legendasVigencias">
            <ng-container *ngTemplateOutlet="legendaCorAto; context:{cor:legenda.cor,txt:legenda.txt}"></ng-container>
        </li>
    </ul>
    <ul class="legenda">
        <li *ngFor="let legenda of legendasSimbolos">
            <ng-container *ngTemplateOutlet="legendaSimboloPequeno; context:{cor:legenda.cor,txt:legenda.txt}"></ng-container>
        </li>
    </ul>
    <span class="mensagem-legenda">
        Clique único no ato que deseja consultar: visão relacional
    </span>
    <span class="mensagem-legenda">
        Clique duplo no ato que deseja consultar: visão multivigente
    </span>
</div>
</ng-container>

<ng-template #circuloGrande let-impacto="impacto">
    <div class="circulo-grande" [title]="impacto.hint">
        <em class="material-icons seta" [style]="getStyleCorSimbolo(impacto.corSimbolo)">trending_flat</em>
        <em class="material-icons bola" >circle</em>
        <em class="material-icons circulo" [style]="getStyleCorSimbolo(impacto.corSimbolo)">radio_button_unchecked</em>
        <div [style]="getStyleCorSimbolo(impacto.corSimbolo)">{{ impacto.sigla }}</div>
    </div>
</ng-template>

<ng-template #circuloFiltro let-filtro="filtro">
    <div class="circulo-filtro" (click)="clickFiltro(filtro)" [title]="filtro.hint">
        <em class="material-icons circulo" [style]="getStyleFiltro(filtro)">radio_button_unchecked</em>
        <em class="material-icons fundo" >circle</em>
        <div class="sigla" [style]="getStyleFiltro(filtro)">{{ filtro.sigla }}</div>
        <span class="quantidade">{{ filtro.quantidade }}</span>
        <em class="material-icons excluir" *ngIf="filtro.selecionado">disabled_by_default</em>
    </div>
</ng-template>

<ng-template #qtdImpactosAno let-quantidade="quantidade">
    <div class="qtd-impactos">
        <em class="material-icons bola" >circle</em>
        <div class="qtd">{{ quantidade }}</div>
    </div>
</ng-template>

<ng-template #legendaCorAto let-c="cor" let-txt="txt">
    <div class="cor-legenda-ato" [style]="{'background-color':'rgb('+c[0]+','+c[1]+','+c[2]+')'}"></div>
    {{ txt }}
</ng-template>

<ng-template #legendaSimboloPequeno let-c="cor" let-txt="txt">
    <div class="circulo-pequeno">
        <em class="material-icons circulo" [style]="{'color':'rgb('+c[0]+','+c[1]+','+c[2]+')'}">radio_button_unchecked</em>
        <em class="material-icons seta" [style]="{'color':'rgb('+c[0]+','+c[1]+','+c[2]+')'}">trending_flat</em>
        <em class="material-icons bola" >circle</em>
        <span>{{ txt }}</span>
    </div>
</ng-template>
